const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAttachVat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M437.333 512c-41.173 0-74.666-33.493-74.666-74.667v-112c0-26.453 21.546-48 48-48 26.453 0 48 21.547 48 48V432c0 8.832-7.168 16-16 16s-16-7.168-16-16V325.333c0-8.81-7.19-16-16-16-8.811 0-16 7.19-16 16v112c0 23.531 19.136 42.667 42.666 42.667C460.864 480 480 460.864 480 437.333v-144c0-8.832 7.168-16 16-16s16 7.168 16 16v144C512 478.507 478.507 512 437.333 512Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.03906 0 0 .03906 2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.947 469.333H58.667C26.304 469.333 0 443.029 0 410.667v-352C0 26.304 26.304 0 58.667 0h266.666C357.696 0 384 26.304 384 58.667v180.906c0 8.832-7.168 16-16 16s-16-7.168-16-16V58.667C352 43.968 340.032 32 325.333 32H58.667C43.968 32 32 43.968 32 58.667v352c0 14.698 11.968 26.666 26.667 26.666h257.28c8.832 0 16 7.168 16 16s-7.168 16-16 16Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.03906 0 0 .03906 2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.886 148.116c-5.765-5.766-15.115-5.766-20.881 0l-194.889 194.89c-5.766 5.766-5.766 15.115 0 20.881a14.72 14.72 0 0 0 10.44 4.325c3.778 0 7.558-1.441 10.44-4.325l194.889-194.889c5.768-5.767 5.768-15.115.001-20.882ZM196.941 123.116c-29.852 0-54.139 24.287-54.139 54.139 0 29.852 24.287 54.139 54.139 54.139 29.852 0 54.139-24.287 54.139-54.139 0-29.852-24.287-54.139-54.139-54.139Zm0 78.747c-13.569 0-24.608-11.039-24.608-24.609 0-13.569 11.039-24.608 24.608-24.608s24.609 11.039 24.609 24.608c-.001 13.57-11.04 24.609-24.609 24.609ZM315.061 280.61c-29.852 0-54.139 24.287-54.139 54.139 0 29.852 24.287 54.139 54.139 54.139 29.852 0 54.139-24.287 54.139-54.139 0-29.852-24.287-54.139-54.139-54.139Zm0 78.747c-13.569 0-24.609-11.039-24.609-24.608s11.039-24.608 24.609-24.608c13.569 0 24.608 11.039 24.608 24.608s-11.039 24.608-24.608 24.608Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.04057 0 0 .03893 -.767 1.202)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAttachVat);
export default __webpack_public_path__ + "static/media/ic-attach-vat.5733ca51b73f636f63e677db6419c14f.svg";
export { ForwardRef as ReactComponent };